import React, { useState } from "react";
import casestudy from "../../assets/FlipImages/1.png";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import global from "../../assets/images/blogs/Global-Expansion-1.png";
import { Helmet } from "react-helmet";
import audit2025img from "../../assets/images/blogs/audit-img-2025.png";

const PCAOBAudit = () => {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [comments, setComments] = useState([]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWebsiteChange = (event) => {
    setWebsite(event.target.value);
  };

  const handleSaveInfoChange = (event) => {
    setSaveInfo(event.target.checked);
  };

  const handleCommentSubmit = () => {
    if (comment.trim() && name.trim() && email.trim()) {
      setComments([...comments, { comment, name, email, website }]);
      setComment("");
      setName("");
      setEmail("");
      setWebsite("");
      setSaveInfo(false);
    }
  };

  return (
    <>

     <Helmet>
        <title>
         PCAOB Audit Standard Updates Effective 2025: Key Changes & Compliance Tips
        </title>
        <meta
          name="description"
          content="PCAOB auditing standards change in 2025—discover key updates, new compliance rules, and how your business can prepare now."
        />
        <meta
          name="keywords"
          content="PCAOB 2025 audit standards, AS 1105 audit evidence 2025, QC 1000 quality control PCAOB, PCAOB compliance tips 2025"
        />
      </Helmet>

      <style jsx>{`
        h4 {
          font-size: 18px;
        }
        h3 {
          font-size: 28px;
        }
        span {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
        li {
          font-size: 16px;
          font-weight: 500;
        }
        .mainCard {
          height: 20rem;
        }
        .circle {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          overflow: hidden;
        }
        i {
          color: #072f5f;
        }
        ul {
          padding-left: 17px;
        }
        @media (max-width: 574px) {
          .mTop {
            margin-top: 30px;
          }
          p {
            font-size: 18px;
          }
          .img-fluid {
            min-height: 100px;
          }
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (min-width: 992px) {
          /* for banner image */
          .bmTop {
            margin-top: 130px;
          }
        }
        @media (max-width: 574px) {
          .banner-image {
            margin-top: 70px; /* Adjust this value for mobile view */
          }
        }
      `}</style>

      <section className="">
        <div
          className="d-flex justify-content-center align-items-center banner-image"
          style={{
            background: `url(${casestudy}) no-repeat center`,
            backgroundSize: "cover",
            height: "200px",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3
              className="text-white text-uppercase text-center"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              PCAOB Audit Standard Updates Effective 2025: <br /> Key Changes &
              Compliance Tips
            </h3>
          </div>
        </div>
        <div className="container-fluid">
          <div
            className="d-flex row justify-content-center align-items-start"
            style={{ gap: "2rem" }}
          >
            <div
              className="col-lg-8 mt-50 mb-50 border shadow"
              style={{ padding: "2rem" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                  <div
                    style={{
                      background: "#072f5f",
                      display: "inline",
                      width: "fit-content",
                      padding: "0.2rem 1rem 0.2rem 1rem",
                    }}
                  >
                    <small
                      className="text-uppercase text-white"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Introduction
                    </small>
                  </div>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      ></span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      PCAOB auditing standards change in 2025—discover key
                      updates, new compliance rules, and how your business can
                      prepare now.
                    </p>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        PCAOB Auditing Standards Updates: Key Information for
                        Companies with Respect to Fiscal Years Ending on or
                        After June 15, 2025
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      The Public Company Accounting Oversight Board (PCAOB) has
                      implemented sweeping changes to auditing standards that
                      will revolutionize the performance of audits for fiscal
                      years ending after June 15, 2025. The changes are the most
                      significant modernization of audit procedures in three
                      decades and have a direct impact on public companies,
                      audit firms, and stakeholders in all industries.
                    </p>

                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Significant PCAOB Standards Becoming Effective on June
                        15, 2025
                      </span>
                    </div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Enhanced Audit Evidence Requirements (AS 1105)
                      </span>
                    </div>
                    
                      <li>
                       The SEC-approved changes to AS 1105, Audit Evidence,
                        significantly change auditors' evidence collection and
                        assessment processes. The revised standard emphasizes
                        technology-facilitated data analysis more than ever
                        before, compelling auditors to use sophisticated
                        analytical tools instead of simple classical sampling
                        procedures. This change provides broader audit coverage
                        and improves identification of material misstatements in
                        today's highly digitalized business environment.
                      </li>
                      <li>
                      <b>  Compliance Confidence : </b> International tax compliance
                        mistakes can result in hefty penalties, legal issues,
                        and damaged business relationships. Professional
                        outsourced CPA services ensure your business stays
                        compliant with local regulations, from VAT requirements
                        in Europe to GST obligations in Australia.
                      </li>
                  </div>

                  <div className="mt-15">
                    <span
                      className="text-capitalize"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#002249",
                      }}
                    >
                      Modern Confirmation Procedures (AS 2310)
                    </span>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    AS 2310, The Auditor's Use of Confirmation, is a
                    comprehensive revision of confirmation procedures unchanged
                    since 2003. The new standard incorporates contemporary
                    communication methods, electronic confirmations, and
                    e-business procedures. Auditors are now required to apply
                    more robust confirmation procedures to mitigate
                    cybersecurity risks and electronic fraud tactics that did
                    not exist in significant numbers two decades ago.
                  </p>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Risk Assessment and Response Framework (AS 2301)
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      The revisions to AS 2301, The Auditor's Responses to the
                      Risks of Material Misstatement, supplement AS 1105 in
                      bringing about a more integrated risk-based auditing
                      framework. This standard requires auditors to make more
                      explicit connections between observed risks and their
                      related audit responses, with a specific focus on
                      procedures facilitated through technology.
                    </p>
                  </div>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Implementation Schedule and Compliance Specifications
                      </span>
                    </div>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    The PCAOB has taken a phased implementation approach to
                    these standards. The three key standards will be mandatory
                    for fiscal years ending on or after June 15, 2025, for
                    financial statement audits. Firms must begin preparing at
                    once because the new requirements will significantly impact
                    audit planning, execution, and documentation procedures.
                  </p>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    The Quality Control Standard (QC 1000) will also be
                    applicable at this stage, imposing new firm-level quality
                    management requirements that augment the individual audit
                    standards.
                  </p>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Strategic Implications for Your Business{" "}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Increasing Demand for Data Analysis
                      </span>
                    </div>
                  </div>

                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Organizations need to prepare for more detailed data
                    requests from auditors. The new requirements demand that
                    auditors use rigorous data analysis, which means your
                    organization must ensure data integrity, availability, and
                    adequate documentation of electronic records.
                  </p>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Enhanced Procedures for Confirmation
                      </span>
                    </div>
                  </div>

                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    The new confirmation requirements will enhance audit
                    effectiveness with higher reliability. Organizations need to
                    revisit their confirmation response procedures and install
                    electronic confirmation systems to facilitate the new
                    requirements.
                  </p>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Documentation and Internal Controls
                      </span>
                    </div>
                  </div>

                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    The new regulations place greater emphasis on the quality of
                    documentation and the strength of internal controls. Firms
                    are required to continuously enhance their internal control
                    systems and maintain complete documentation of business
                    processes and transactions.{" "}
                  </p>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Preparing for the Transition
                      </span>
                    </div>
                  </div>

                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    To ensure effective compliance with the new PCAOB auditing
                    standards, organizations must:
                  </p>

                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>
                      1. Measure Current Systems: Compare current data
                      management and internal control systems to new
                      requirements.
                    </li>
                    <li>
                      2. Improve Documentation: Enhance documentation procedures
                      to facilitate better audit evidence requirements.
                    </li>
                    <li>
                      3. Technology Integration: Leverage technology solutions
                      to enable data analysis and electronic confirmations.{" "}
                    </li>
                     <li>
                     4.	Staff Training: Inform accounting and finance staff of the implications of the new standards.
                    </li>
                  </ul>

                  <img
                    src={audit2025img}
                    style={{
                      display: "block",
                      margin: "1rem auto",
                      width: "350px",
                      height: "270px",
                    }}
                  />

                    <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                       Work with Experienced Experts
                      </span>
                    </div>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                  The intricacy of such PCAOB revisions necessitates professional counsel to navigate successfully. Boston FA Group's experienced professionals are always up-to-date with all regulatory revisions, ensuring your business remains compliant while optimizing audit efficiency. 
                  </p>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                  These PCAOB auditing standard revisions represent a sea change toward technology-facilitated, risk-based auditing that will enhance audit quality and investor protection. Organizations that prepare for and adapt to these developments will experience smoother audits and more effective internal controls.
                  </p>

                  <Box
                    mt="2rem"
                    p="2rem"
                    border="1px solid #ddd"
                    borderRadius="8px"
                  >
                    <Typography variant="h5" gutterBottom>
                      Leave a Comment
                    </Typography>
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={comment}
                      onChange={handleCommentChange}
                      margin="normal"
                    />
                    <Box display="flex" gap="1rem">
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={handleNameChange}
                        margin="normal"
                      />
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={handleEmailChange}
                        margin="normal"
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={saveInfo}
                          onChange={handleSaveInfoChange}
                        />
                      }
                      label="Save my name, email, and website in this browser for the next time I comment."
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCommentSubmit}
                      style={{ backgroundColor: "rgb(0, 34, 73)" }}
                    >
                      Send Comment
                    </Button>
                  </Box>
                  <Box mt="2rem">
                    {comments.map((cmt, index) => (
                      <Box
                        key={index}
                        mt="1rem"
                        p="1rem"
                        border="1px solid #ddd"
                        borderRadius="8px"
                      >
                        <Typography variant="body1">{cmt.comment}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cmt.name} - {cmt.email}
                          {cmt.website && ` - ${cmt.website}`}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PCAOBAudit;
